











































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Surface, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import CampaignAppPreview from '@/componentsV2/organisms/SellCoins/Campaign/CampaignAppPreview.vue';
import CampaignSettingsPreview from '@/componentsV2/organisms/SellCoins/Campaign/CampaignSettingsPreview.vue';

import { TDeadLineType } from '@/models/marketingCenter/freeCoins';

@Component({
  components: {
    Surface,
    Typography,
    FilledButton,
    CampaignAppPreview,
    CampaignSettingsPreview
  }
})
export default class CampaignSideBar extends Vue {
  @Prop() campaignName?: string;
  @Prop() bonusPercentage?: string;
  @Prop() expiration?: string;
  @Prop() expirationType?: TDeadLineType;
  @Prop() loading?: boolean;

  createCampaign() {
    this.$emit('save-click');
  }

  get tPrefix() {
    return 'sellCoins.campaign.sideBar';
  }
}
